import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, VALUE_ENTER, CODE_SPACE } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizButton,
  WizCheckbox,
  WizDatasource,
  WizDropdown,
  WizLabel,
  WizTextInput,
  WizVgroup,
  WizHgroup,
  WizImage,
  GridDNDConfig,
  ImageUploadParameter,
  WizEventManager, WizEvent,
  WizTranslationManager,
  WizTextarea
} from '@wizeoo/akm-component-lib';
import { of } from 'rxjs/internal/observable/of';
import { FIELD_KIND } from '@wizeoo/akm-compute-lib';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { GridOptions } from 'ag-grid-community';
import { ColDef } from 'ag-grid-community';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { Model } from '../../../../model/model';
import { ViewData } from '../../../../model/view.data';
import { FormatVO } from '../../../../vo/workingdata/format.vo';
import { ArgEditorData } from '../../freedatas/renderers/args.renderer';
import { FreedataArgsVO } from  '../../../../vo/core/freedataargs.vo';
import { ConnectVO } from '../../../../vo/core/connect.vo';
import { AttachmentService } from "../../../../command/core/attachment/attachment.service";
import { AngularEditorComponent, AngularEditorConfig } from '@wfpena/angular-wysiwyg';
import { CssRenderVO } from '../../../../vo/workingdata/cssrender.vo';


/** contrat d'interface pour les données manipulée dans cette PopUp */
export interface FreedataFieldSettingsPopVO {
  model: Model;
  argData: ArgEditorData;
  context: GridsterWidgetItem,
  updateCallback: Function;
}

export interface FreedataFieldSettingsResult {
  field: string, // champ sur le FDV, code pour les Fakes
  showLabel: boolean, // afficher le libellé
  label: string, // libellé
  format?: string, // format de rendu
  ro?:boolean, // lecture seule
  fdvSearch?: string, // code des champs affichés, séparés par | pour affichage & recherche dans la popUp de sélection
  style?: string, // style custom
  noClone?: boolean, // pas cloné
  pgrp?: string, // groupe d'appartenance
  pmdexParams?: string // configuration avancée (workflow)
}

@Component({
  // popUp d'édition des champs de pivot: style, label, méthode d'aggrégat
  selector: 'freedata-field-settings-pop',
  templateUrl: './freedata-field-settings.pop.html',
})
export class FreedataFieldSettingsPop extends WizBasePopUp {
  /** Zone de detail (pour updateEvent) */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;
  @ViewChild('lbTitle', { read: WizLabel, static: false }) lbTitle: WizLabel; // titre de la popUp (fullcode)
  @ViewChild('btnSave', { read: WizButton, static: true }) btnSave: WizButton; // bt save


  @ViewChild('gpLabel', { read: WizVgroup, static: false }) gpLabel: WizVgroup; // gestion du label
    @ViewChild('tiLabel', { read: WizTextInput, static: false }) tiLabel: WizTextInput; // libellé custom
    @ViewChild('tiGrp', { read: WizTextInput, static: false }) tiGrp: WizTextInput; // groupe d'appartenance
    @ViewChild('cbShowLabel', { read: WizCheckbox }) cbShowLabel: WizCheckbox; // cb d'affichage du libellé
    
  @ViewChild('gpDrop', { read: WizVgroup, static: false }) gpDrop: WizVgroup; // gestion de la zone de drop
    @ViewChild('tiPath', { read: WizTextInput, static: false }) tiPath: WizTextInput; // path
    @ViewChild('cbNoEncode', { read: WizCheckbox }) cbNoEncode: WizCheckbox; // pas d'encodage
    

  @ViewChild('gpFormat', { read: WizHgroup, static: false }) gpFormat: WizHgroup;
    @ViewChild('ddField', { read: WizDropdown }) ddField: WizDropdown; // drop de choix du champ de label des FDVs
    @ViewChild('ddFormat', { read: WizDropdown }) ddFormat: WizDropdown; // drop de choix du formatage
    @ViewChild('ddStyle', { read: WizDropdown }) ddStyle: WizDropdown; // drop de choix du style
    @ViewChild('cbReadOnly', { read: WizCheckbox, static: true }) cbReadOnly: WizCheckbox; // col éditable en lecture seule
    @ViewChild('cbNoClone', { read: WizCheckbox, static: true }) cbNoClone: WizCheckbox; // champ non cloné
   
  @ViewChild('gpFields', { read: WizVgroup, static: false }) gpFields: WizVgroup; // choix du champ en cas de FD / chrono  

  @ViewChild('advancedTab', { read: WizVgroup, static: false }) advancedTab: WizVgroup; // settings pour Workflow
  @ViewChild('taSettings', { read: WizTextarea, static: false }) taSettings: WizTextarea; // settings pour Workflow


  @ViewChild('gpHhtmlEditor', { read: WizHgroup, static: false }) gpHhtmlEditor: WizHgroup;
  @ViewChild('aed') aed: AngularEditorComponent; // bt save


    
  @ViewChild('gpConnect', { read: WizVgroup, static: false }) gpConnect: WizVgroup;
    @ViewChild('ddConnect', { read: WizDropdown }) ddConnect: WizDropdown; // drop de choix du champ de la fonction
    @ViewChild('btConnect', { read: WizButton }) btConnect: WizButton; // bouton de rendu de la fonction
 
  @ViewChild('imgGp', { read: WizHgroup, static: false }) imgGp: WizHgroup; // image libre
    @ViewChild('img', { read: WizImage, static: false }) img: WizImage;
  
  htmlContent: string = '';
  

  /** configuration de l'editeur html */
  public editorConfig:AngularEditorConfig = {
    width: '100%',
    height: '100%',
    editable: true,
    enableToolbar: true,
    showToolbar: true, 
    spellcheck: false,
    sanitize: false,
    placeholder: 'Tapez votre texte ici...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'calibri',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
    ],
  }

  public get model(): Model {
    return Model.getInstance();
  }

  /** DS de la drop des champs de rendu pour les FDVs */
  public fieldDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    //.setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('single')
    .build();

  /** DS du grid des champs de sélection pour les FDVs */  
  public fieldsDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFn(this.sortSelectedFirst.bind(this))
    .setSelectionMode('multiple')
    .build();

    public searchFields: string[] = []; // mémorisation des clés de searchField pour sort custom
    /**
     * sort custom pour placer les searchFields sélectionnés en premier
     * @param itemA 
     * @param item 
     */
    public sortSelectedFirst(itemA: FreedataArgsVO, itemB: FreedataArgsVO): number {
      // console.log('sort', itemA, itemB, this.searchFields);
      let idxOfA: number = -1;
      let idxOfB: number = -1;
      if (this.searchFields) {
        idxOfA = this.searchFields.indexOf(itemA.code) >-1 ? this.searchFields.indexOf(itemA.code) : -1;
        idxOfB = this.searchFields.indexOf(itemB.code) >-1 ? this.searchFields.indexOf(itemB.code) : -1;
      }
  
      if (idxOfA === -1) {
        idxOfA = 1000 + itemA.order;
      }
  
      if (idxOfB  === -1) {
        idxOfB = 1000 + itemB.order;
      }
  
      let result: number = 1;
      if(idxOfB - idxOfA >= 0) {
        result = -1;
      }
      // console.log('##A',idxOfA, itemA.code, "##B",idxOfB, itemB.code, "##Res", result);
      return result;
    }

  // colonne du grid
  public columns: ColDef[] = [
    { headerName: '$.field.shortcode.$',dndSource: true, flex: 1, sortable: true, field: 'trsLabel' }
  ];

  gridOptions: GridOptions = {
  };

  // configuration du drag
  public dndConfig: GridDNDConfig<FreedataArgsVO> = {
    dragEnabled: true,
    dropEnabled: true,
    dropAction: 'reorder'
  };


  /** DS de la drop des formats */
  public formatDS: WizDatasource<FormatVO> = new WizDatasource<FormatVO>([])
    .setFilter(this.dataFormatFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop des styles */
  public styleDS: WizDatasource<CssRenderVO> = new WizDatasource<CssRenderVO>([])
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();


  /** DS des fonctions Connect */
  public connectDS: WizDatasource<ConnectVO> = new WizDatasource<ConnectVO>()
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();


  private doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)

  public declare datas: FreedataFieldSettingsPopVO; // le contrat de données pour la pop

  public get field(): PivotField {
    return this.datas?.context?.field as PivotField;
  }

  public get context(): WidgetConfigurationItemObj {
    return this.field?.contextItem;
  }


  public static baseHeight: number = 600; // hauteur avec tout, statique pour prise externe sur ouverture
  public static baseWidth: number = 600; // largeur, statique pour prise externe sur ouverture


  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  public show(): void {
    super.show();

    const buCnx: Map<string, ConnectVO> = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode);
    const cnxArr: ConnectVO[] = !!buCnx ? [...buCnx.values()] : [];
    this.connectDS.setSource(cnxArr);

    setTimeout(() => {
      this.feed(); // alimentation des données et DS
      this.addListeners();
    }, 0);
  }

  public isFreedataField:boolean = false; //sous-fd, choix du champ
  public isFake:boolean = false; //libellé / title
  private _fakeKind: string; // type de rendu libre
  private _currentImg: string = null; // image libre en cours

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feed(): void {
    
    if(!!this.model.formatEngine.getFormatList()) {
      this.formatDS.setSource(this.model.formatEngine.getFormatList());
    }

    // TODO filter à la BU
    if(!!this.model.styleEngine.getCssRenderList()) {
      this.styleDS.setSource(this.model.styleEngine.getCssRenderList());
    }

  if(!this.datas.argData.arg) { // fake
    
    this.isFake = true;
    this._fakeKind = this.context.fdvf;

    switch(this._fakeKind) {
      case ViewData.FORM_HTML:
        this.gpHhtmlEditor.visible = true;
        this.lbTitle.wizLabel = '$.common.free.content.$';
        //setTimeout(() => {
          this.aed.placeholder='';
          this.aed.showPlaceholder = false;
          //this.aed.config = this.editorConfig;
          this.aed?.writeValue(this.context.lbl || null); // WizTranslationManager.getInstance().translateKey('$.common.free.content.$'));
          //this.cdref.markForCheck();
          //console.log('timed ffs', this.aed);
        //}, 0);

      break;
      case ViewData.FORM_IMAGE:
        this.lbTitle.wizLabel = '$.common.free.image.$';
        this.imgGp.visible = true;
          if(!!this.context.lbl) {
            this._currentImg = this.context.lbl;
            this.img.sourceObservable = AttachmentService.getInstance().downloadAttachmentForWidget(this._currentImg);
          } else {
            this.img.sourceObservable = of(null);
          }
        // console.log('edit image', this.field.contextItem);
      break;
      case ViewData.FORM_ACTION:
        this.lbTitle.wizLabel = '$.common.free.action.$';
        this.gpConnect.visible = true;
        this.ddConnect.wizDataProvider = this.connectDS;

        const cnx: ConnectVO = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(this.context.lbl);
        this.feedConnectButton(cnx);
        // console.log('edit action', this.field.contextItem);
      break;
      case ViewData.FORM_DROP:
        this.lbTitle.wizLabel = '$.common.free.drop.$';
        this.gpDrop.visible = true;
        this.tiPath.wizValue = this.context.subField; // on recycle le subField
        this.cbNoEncode.wizChecked = this.context?.slbl; // on recycle le showLabel
      break;

      case ViewData.FORM_ZONE:
        this.lbTitle.wizLabel = '$.common.free.zone.$';
        this.gpLabel.visible = true;
        this.gpFormat.visible = true;
        if (!!this.context?.lbl) { // label custom  
          this.tiLabel.wizValue = this.context.lbl;
        } else {
          this.tiLabel.wizValue = WizTranslationManager.getInstance().translateKey('$.common.free.zone.$');
          // this.tiLabel.wizValue = '$.common.free.zone.$';
        }
        if (!!this.context?.pgrp) { // label du groupe
          this.tiGrp.wizValue = this.context.pgrp;
        } else {
          this.tiGrp.wizValue = '';
        }

        let style: CssRenderVO = null; // le style 
        if (this.context.sty) {
          style = this.styleDS.getItemByKey(this.context.sty);
        }
        this.styleDS.select([style]);
        this.ddStyle.wizDataProvider = this.styleDS;

        break;
      }


  } else { // un vrai champ
    this.gpLabel.visible = true;
    this.gpFormat.visible = true;

    if (!!this.context?.lbl) { // label custom  
      this.tiLabel.wizValue = this.context.lbl;
    } else {
      this.tiLabel.wizValue = this.datas.argData.arg.trsLabel;
    }
    
    if (!!this.context?.pgrp) { // label du groupe
      this.tiGrp.wizValue = this.context.pgrp;
    } else {
      this.tiGrp.wizValue = '';
    }

    this.lbTitle.wizLabel = this.datas.argData.arg.trsLabel;

    /** c'est un champ de référence à un autre FD (pour affichage settings) */
    if (this.datas.argData.arg.dataType === FIELD_KIND.OBJECT) {
      // on collecte le bon FD
      const keyPair: string = this.datas.argData.arg.datas;
      const args: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(keyPair.split(ViewData.CONTEXT_SEPARATOR)[0]);
    
      this.fieldDS.setSource([...args]);
  
      if (!!this.context.subField) {
        this.fieldDS.select([this.fieldDS.getItemByKey(this.context.subField)]);
      }
  
      this.ddField.wizDataProvider = this.fieldDS;
      this.isFreedataField = true;

      // on collecte le bon FD
      this.gpFields.visible = true;
      this.fieldsDS.setSource([...args]);

      if (!!this.context.fdvSearch) { // champs sélectionné pour rendu des pops de sélection
        this.searchFields = this.context.fdvSearch.split(ViewData.KEY_SEPARATOR);

        // const vals: string[] = this.field.wcio.fdvSearch.split(ViewData.KEY_SEPARATOR);
        const valArgs: FreedataArgsVO[] = this.searchFields.map(item => this.fieldsDS.getItemByKey(item));
        // console.log('valargs', valArgs);
        this.fieldsDS.select(valArgs);
        this.fieldsDS.doSort(this.fieldsDS.getSource()); // on ré-applique le tri
      } 
    }

    if (this.datas.argData.arg.dataType === FIELD_KIND.WORKFLOW) {
      this.advancedTab.visible = true;
      this.taSettings.wizValue = this.context.pmdexParams;
    }

    // gestion du format TODO prendre en compte le sous-objet en cas de subFD
    this.formatDS.refresh(); // actualisation de la drop des formats
    let format: FormatVO = null; // le format de données
    let formatSplit: string[] = null;
    if (this.context.fmt) {
      formatSplit = this.context.fmt.split(ViewData.KEY_SEPARATOR);
      format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
    } else if (!!this.field?.fkd?.defaultFormat) {
      formatSplit = this.field?.fkd?.defaultFormat.split(ViewData.KEY_SEPARATOR);
      format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
    }
    this.formatDS.select([format]);
    this.ddFormat.wizDataProvider = this.formatDS;


    let style: CssRenderVO = null; // le style 
    if (this.context.sty) {
      style = this.styleDS.getItemByKey(this.context.sty);
    }
    this.styleDS.select([style]);
    this.ddStyle.wizDataProvider = this.styleDS;


    this.cbReadOnly.wizChecked = this.context?.ro;
    this.cbNoClone.wizChecked = this.context?.noc;

    this.cbShowLabel.wizChecked = this.context?.slbl;

  }

  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
  }

  /** feed initial ou refresh sur une fonction connect libre */
  private feedConnectButton(cnx: ConnectVO): void {
    if (!!cnx) {
      this.btConnect.wizLabel = cnx.trsLabel;
      this.btConnect.tooltipText = cnx.trsDescription;
      this.btConnect.wizImage = cnx.iconOrDie;
    } else {
      this.btConnect.wizLabel = '$.connect.unknow.$';
      this.btConnect.tooltipText = '$.connect.unknow.$';
      this.btConnect.wizImage = AttachmentService.getInstance().iconOrDie(null, this.model.domainCode, this.model.businessUnitCode, ViewData.wildcardMainVision);
    }
  }

  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // console.log('updateModel', e.value);
    switch (e.component) {
      case this.ddConnect: {
        const cnx: ConnectVO = this.ddConnect.selectedItem;
        this.feedConnectButton(cnx);
        break;
      }
    }
  }

  /* ##############################################################################
                   sauvegarde
     ############################################################################## */

  /** Sauvegarde */
  public save(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /** sur hide, tentative d'enregistrement */
  public onHide() {
    if (this.doSaveFlag) {
      let code: string = null;
      if (this.fieldDS?.selectedItem) {
        code = this.fieldDS.selectedItem.code;
      } 

      let fdvSearch: string = null;
      if (this.fieldsDS.selectedItems) {
        const parts: Set<string> = new Set(this.fieldsDS.selectedItems.map(item => item.code));
        const orderedParts: string[] = []; // on les prend dans le bon ordre
        this.fieldsDS.getWorkedSource().forEach((arg: FreedataArgsVO) => {
          if(parts.has(arg.code)) {
            orderedParts.push(arg.code);
          }
        });

        // console.log('parts', parts, orderedParts);
        fdvSearch = orderedParts.join(ViewData.KEY_SEPARATOR);
      }

      let result: FreedataFieldSettingsResult = {field: null, showLabel: true, label: null};
      if(this.isFake) {
        switch(this._fakeKind) {
          case ViewData.FORM_HTML:
            let chtemeleu = this.aed.editHistory.pop();
            //this.datas.updateCallback(code, false, chtemeleu, null, false);
            result.field = code;
            result.showLabel = false;
            result.label = chtemeleu;
          break;
          case ViewData.FORM_IMAGE:
            result.field = code;
            result.showLabel = false;
            result.label = this._currentImg;
            // this.datas.updateCallback(code, false, this._currentImg, null, false);
          break;
          case ViewData.FORM_ACTION:
            const connect: ConnectVO = this.connectDS.selectedItem;
            const connectCode: string = connect ? connect.code : null;
            result.field = code;
            result.showLabel = false;
            result.label = connectCode;
            //this.datas.updateCallback(code, false, connectCode, null, false);
          break;
          case ViewData.FORM_DROP:
            // this.datas.updateCallback(code, this.cbNoEncode.wizChecked, null, null, false, this.tiPath.wizValue || 'root');
            result.field = code;
            result.showLabel = this.cbNoEncode.wizChecked;
            result.fdvSearch = this.tiPath.wizValue || 'root';
          break;
          case ViewData.FORM_ZONE:
            result.field = code;
            result.label = this.tiLabel.wizValue;
            result.showLabel = true;
            result.pgrp = this.tiGrp.wizValue;
            const style: CssRenderVO = this.styleDS.selectedItem;
            result.style = style?.code || null;
            // this.datas.updateCallback(code, false, null, null, false, this.tiPath.wizValue || 'root');
          break;
        }

        //this.datas.updateCallback(result);
      } else { // champ du FDV
        // gestion du format
        const format: FormatVO = this.formatDS.selectedItem;
        const formatCode: string = format ? format.businessUnitCode + ViewData.KEY_SEPARATOR + format.code : null;

        const style: CssRenderVO = this.styleDS.selectedItem;
        const styleCode: string = style?.code || null;

            result.field = code;
            result.showLabel = this.cbShowLabel.wizChecked;
            result.label = this.tiLabel.wizValue;
            result.format = formatCode;
            result.ro = this.cbReadOnly.wizChecked;
            result.fdvSearch = fdvSearch;
            result.style = styleCode;
            result.noClone = this.cbNoClone.wizChecked;
            result.pgrp = this.tiGrp.wizValue;
        
            result.pmdexParams = this.taSettings.wizValue;

        // this.field.wcio.fmt = formatCode;
        // this.datas.updateCallback(code, this.cbShowLabel.wizChecked, this.tiLabel.wizValue, formatCode, this.cbReadOnly.wizChecked, fdvSearch, styleCode, this.cbNoClone.wizChecked);
      }
      this.datas.updateCallback(result);
    }
  }

  /**
   * filterFunc de la liste des formats, selon le type de la données
   * @param e la fonction
   */
  public dataFormatFilter(fm: FormatVO): boolean {
    
    let targetDatakind: string = this.datas?.argData?.arg?.dataType; // this.arg.dataType;

    if(targetDatakind === FIELD_KIND.FORMULA) { // tous les formats OK pour les formules
      return true;
    }

    return fm.dataKind === this.datas?.argData?.arg?.dataType;
  }

  /**
   * Demande de chargement d'une image
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public clickForUpload(): void {

    let params: ImageUploadParameter = {
      component: this.img,
      elementRef: this.img.elementRef,
      dom: this.model.domainCode,
      bu: this.model.businessUnitCode,
      vision: ViewData.wildcardMainVision,
      viewCallback: this.uploadCallback.bind(this)
    }
    this.model.batchEngine.loadImage(params);
  }

  /**
   * demande d'ouverture sur l'image picker par clavier; touche entrée ou espace
   * @param event event clavier
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public keydownForUpload(event: KeyboardEvent): void {
    const isEnterKey = event.key === VALUE_ENTER; // touche entrée
    const isSpaceKey = event.code === CODE_SPACE; // touche espace
    if (isEnterKey || isSpaceKey) {
      this.clickForUpload();
    }
  }

  /**
   * Callback de l'upload d'image sur FD
   * @param files Le fichier
   * @param fileStr byte[] au format String
   */
  private uploadCallback(blobId: string): void {
    if (blobId) {
      this._currentImg = blobId;
      this.img.sourceObservable = AttachmentService.getInstance().downloadAttachmentForWidget(blobId);
    } else {
      this.img.sourceObservable = of(null);
    }
  }



}
